var STUDIO_URL = 'https://studio.atlassian.com';
var STUDIO_URL_STAGING = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
var isStaging = function isStaging() {
  var host = window.location.host;
  return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
export var getStudioEditorUrl = function getStudioEditorUrl(helpCenterId, cloudId, pageId) {
  var studioUrl = isStaging() ? STUDIO_URL_STAGING : STUDIO_URL;
  if (!pageId) {
    return "".concat(studioUrl, "/s/").concat(cloudId, "/hubs/").concat(helpCenterId);
  }
  return "".concat(studioUrl, "/s/").concat(cloudId, "/hubs/").concat(helpCenterId, "/pages/").concat(pageId);
};